import { Outlet } from 'react-router';
import { Card, CardBody, CardHeader } from '@heroui/react';
import { LazyMotion, AnimatePresence, domAnimation } from 'framer-motion';
import { PasswordProvider } from '@/features/password';

const withPasswordProvider = WrappedComponent => {
  const Wrapped = ({ ...rest }) => (
    <PasswordProvider>
      <WrappedComponent {...rest} />
    </PasswordProvider>
  );

  return Wrapped;
};

export const Layout = withPasswordProvider(() => {
  return (
    <Card className="w-full max-w-sm items-center bg-white/0">
      <CardHeader className="bg-white/30 backdrop-blur-md justify-center">
        <div className="flex flex-col items-center">
          <img
            src="//cdn.lifebeacon.com/img/logo_primary.png"
            alt="LiveFree Logo"
            width="200"
          ></img>
        </div>
      </CardHeader>
      <CardBody className="bg-white/20 backdrop-blur-md p-4">
        <LazyMotion features={domAnimation}>
          <AnimatePresence initial={false} mode="wait">
            <Outlet />
          </AnimatePresence>
        </LazyMotion>
      </CardBody>
    </Card>
  );
});
